<template>
    <div class="about">
        <div :class="{'banner':true,'blankBanner':!bannerUrl}">
            <img style="cursor:pointer" @click="changeLink()" :src="bannerUrl" alt="">
        </div>
        <div class="body">
            <wrap 
            :title="menuList"
            :cateName="cateName"
            :location="location"
            @change-page="changePage"
            :selectedKeys="selectedKeys"
            :isCenter="true"
            :modelName="'关于我们'">
                <slot>
                    <router-view></router-view>
                </slot>
            </wrap>
        </div>
    </div>
</template>
<script>
import {getBannerListApi} from "@/request/api"
import wrap from "@/components/wrap"
export default {
    name:"about",
    components:{wrap},
    watch:{
        '$route':function(){
            let path=window.location.pathname.split('/')
            this.switchFun(path[path.length-1])
        }
    },
    mounted(){
        this.cateName='公司介绍'
        let path=window.location.pathname.split('/')
        this.switchFun(path[path.length-1])
        this.init()
    },
    data(){
        return{
            menuList:[{
                    title:'公司介绍',
                    id:'1',
                    menuList:''
                },{
                    title:'荣誉资质',
                    id:'2',
                    menuList:'',
                },{
                    title:'人才计划',
                    id:'3',
                    menuList:'',
                },{
                    title:'公司新闻',
                    id:'4',
                    menuList:''
                },{
                    title:'校企合作',
                    id:'5',
                    menuList:'',
                },{
                    title:'联系我们',
                    id:'7',
                    menuList:'',
                }
            ],
            location:['关于我们','公司介绍'],
            cateName:'',
            selectedKeys:['1'],
            bannerUrl:"",
            bannerLink:''
        }
    },
    methods:{
        init(){
            this.getToken(getBannerListApi,{},res=>{
                this.bannerUrl=res.data.filter(item=>item.link==6)[0].banner_img
                this.bannerLink=res.data.filter(item=>item.link==6)[0].banner_name
            })
        },
        changePage(data){
            let route = ''
            switch(data[0]){
                case '1' : route = '/aboutIntroduction';this.cateName=this.location[1] = '公司介绍'
                break;
                case '2' : route = '/aboutHonour';this.cateName=this.location[1] = '荣誉资质'
                break;
                case '3' : route = '/aboutTalent';this.cateName=this.location[1] = '人才计划'
                break;
                case '4' : route = '/aboutNews';this.cateName=this.location[1] = '公司新闻'
                break;
                case '5' : route = '/aboutOperative';this.cateName=this.location[1] = '校企合作'
                break;
                case '6' : route = '/aboutTechnical';this.cateName=this.location[1] = '技术支持'
                break;
                case '7' : route = '/aboutUs';this.cateName=this.location[1] = '联系我们'
                break;
            }
            this.$router.push({path:route})
        },
        switchFun(data){
            switch(data){
                case 'aboutIntroduction' : this.selectedKeys=['1'];this.cateName="公司介绍"
                break;
                case 'aboutHonour' : this.selectedKeys=['2'];this.cateName="荣誉资质"
                break;
                case 'aboutTalent' : this.selectedKeys=['3'];this.cateName="人才计划"
                break;
                case 'aboutNews' : this.selectedKeys=['4'];this.cateName="公司新闻"
                break;
                case 'aboutDetailNews' : this.selectedKeys=['4'];this.cateName="公司新闻"
                break;
                case 'aboutOperative' : this.selectedKeys=['5'];this.cateName="校企合作"
                break;
                case 'aboutUs' : this.selectedKeys=['7'];this.cateName="联系我们"
                break;
                default:
                    this.selectedKeys=['4'];this.cateName="公司新闻"
            }
        },
        changeLink(){
            if(this.bannerLink){
                window.open(this.bannerLink, '_blank')
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.about
    .banner
        img 
            width:100%;
    .body   
        background:#f3f3f2
</style>